<template>
    <div class="modal fade" id="Hold" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="col-12 my-auto">
                        <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal"
                                    id="closeHoldBill" aria-label="Close"></i></a></span>
                    </div>
                </div>
                <div class="container-fluid" v-if="details">
                    <form @submit.prevent="submit">
                        <div class="modal-body">
                            <div class="container-fluid">
                                <div class="row mt-2">
                                    <div class="col-sm-12">
                                        <p class="font-weight-bold d-inline">Reason(s):</p>
                                        <div class="row">
                                            <div class="col-12">
                                                <textarea
                                                    maxlength="500"
                                                    v-model="statusNarrative"
                                                    class="form-control z-depth-1"
                                                    rows="3">
                                                </textarea>
                                              <div class="text-right small text-muted mt-1">
                                                {{ (statusNarrative || '').length }}/500
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <p class="font-weight-bold">Are you sure you want to place this bill on hold?
                                        </p>
                                    </div>
                                    <div class="col-sm-12 text-center no-pad">
                                        <button type="submit" class="btn btn-hc w-40 mr-2 mb-3"
                                            :disabled="submitStatus === 'PENDING'">Yes</button>
                                        <button type="submit" class="btn btn-hc w-40 ml-2 mb-3" data-dismiss="modal"
                                             aria-label="Close">No</button>
                                    </div>
                                </div>
                                <!-- Are you sure end -->
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      submitStatus: null,
      statusNarrative: null,
    };
  },
  computed: {
    details() {
      return this.$store.state.finances.billDetails;
    },
  },
  methods: {
    submit() {
      setTimeout(() => {
        this.$http
          .put(
            "https://" +
              Vue.config.honeycomb.billbot.domain +
              "/api/v1/OnHold/set",
            {
              StatementId: this.details.Id,
              StatusNarrative: this.statusNarrative,
            },
            {
              withCredentials: true,
            }
          )
          .then(() => {
            this.submitStatus = "OK";
            this.$snotify.success(`Success! Bill placed on hold.`);
            this.$store.dispatch("getBills");
            this.$store.dispatch("getLedger");
            this.$store.dispatch("getCharges");
            this.$store.dispatch("getUsage");
            this.$store.dispatch("refreshReadings");
            this.statusNarrative = null;
            document.getElementById("closeHoldBill").click();
            setTimeout(() => {
              this.$store.dispatch("refreshCustomer");
            }, 3000);
          })
          .catch((error) => {
            // Error
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              this.submitStatus = "Error";
              if (error.response.data.MoreInformation.length > 0) {
                error.response.data.MoreInformation.forEach((e) => {
                  this.$snotify.error(`${e.Error}`, {
                    timeout: 0,
                    closeOnClick: true,
                  });
                });
              } else {
                this.$snotify.error(`${error.response.data.UserDescription}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              this.submitStatus = "Error";
              this.$snotify.error(`No response recieved.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              this.submitStatus = "Error";
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
      }, 1200);
    },
  },
};
</script>
